import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { CardActionProps } from '../../../../components/shared/cardActions/cardActions'
import SimpleDialog from '../../../../components/shared/simpleDialog/simpleDialog'

interface RegenerateChoiceDialogProps {
  open: boolean
  onClose: () => void
  onRegenerate: () => void
  /** Navega a Validar listado sin regenerar */
  onNavigate: () => void
}

export const RegenerateChoiceDialog: React.FC<RegenerateChoiceDialogProps> = ({
  open,
  onClose,
  onRegenerate,
  onNavigate
}) => {
  const [t] = useTranslation(['globalerisLibrary', 'settlementsInvoices'])

  const footerActions: CardActionProps[] = useMemo(
    () => [
      {
        label: t('globalerisLibrary:form.actions.cancel'),
        color: 'secondary',
        handleActionClick: onClose
      },
      {
        label: t('settlementsInvoices:components.regenerateChoiceDialog.navigate'),
        color: 'primary',
        handleActionClick: onNavigate
      },
      {
        label: t('settlementsInvoices:components.regenerateChoiceDialog.regenerate'),
        color: 'primary',
        handleActionClick: onRegenerate
      }
    ],
    [t, onClose, onNavigate, onRegenerate]
  )

  return (
    <SimpleDialog
      open={open}
      handleClose={onClose}
      title={t('settlementsInvoices:components.regenerateChoiceDialog.title')}
      footerActions={footerActions}
      maxWidth="sm"
      formStyle="confirmationDialog"
    >
      {t('settlementsInvoices:components.regenerateChoiceDialog.message')}
    </SimpleDialog>
  )
}
